import * as React from 'react';

import { RouteComponentProps, StaticContext } from 'react-router';
import ELearningContainer from '../containers/ELearning';

/**
 * パスパラメータ
 */
export interface IELearningPathParams {
	career_id: string;
	class_id: string;
}

/**
 * push時に渡すパラメータ
 */
export interface IELearningPushState {
	caller: string;
	outOfPeriodFlg: boolean;
	showTree?: boolean;
}

/**
 * eラーニング受講画面
 * @param props
 */
const ELearningPortal: React.FC<
	RouteComponentProps<
		IELearningPathParams,
		StaticContext,
		IELearningPushState
	>
> = props => {
	return (
		<ELearningContainer
			careerID={props.match.params.career_id}
			classID={props.match.params.class_id}
			outOfPeriodFlg={false}
			preview={false}
			state={props.location.state}
		/>
	);
};

export default ELearningPortal;



// WEBPACK FOOTER //
// ./src/pages/ELearningPortal.tsx